// extracted by mini-css-extract-plugin
module.exports = {"emailNotice":"VerifyCodeNotice_emailNotice__Zka9a","emailAddress":"VerifyCodeNotice_emailAddress__lElvF","resendCode":"VerifyCodeNotice_resendCode___0iTG"};